import { useQuery } from 'react-query'

import { request } from '../../../sharedLegacy/utils/api'
import {
  type APIResponse,
  HTTPMethod,
} from '../../../sharedLegacy/utils/api.types'

import { type LiveSchedulesDTO } from './liveSchedule'

const SCHEDULE_LIVE_KEY = 'schedule_live_key'

const useSchedule = (liveId?: number, token?: string) => {
  return useQuery({
    queryKey: [SCHEDULE_LIVE_KEY, liveId],
    queryFn: async () => {
      if (!liveId || !token) return null

      const { liveschedules: liveSchedules } = await request<
        { live_id: number; token: string },
        APIResponse & LiveSchedulesDTO
      >({
        url: '/api/live/schedule/list',
        method: HTTPMethod.POST,
        data: {
          live_id: liveId,
          token,
        },
      })

      return liveSchedules.find(
        (liveSchedule) => +liveSchedule.live_id === liveId
      )
    },
    cacheTime: Infinity,
    staleTime: Infinity,
  })
}

export { useSchedule }
